import {ReactNode} from "react";

export type NewScore = {
    score_obtained: number;
    out_of: number;
    coefficient: number;
    commentary?: string;
    category?: string;
    date: string;
}
export type RawScore = NewScore & {
    name: string;
    category_name: string;
};

export type ScoreWithStats = RawScore & {
    normalized_score: number;
    cumulativeWeightedAverage: number;
    cumulativeWeightedMedian: number;
};

export type NewCategory = {
    category: string;
    description?: string;
    coefficient: number;
}

export type Category = NewCategory & {
    name: string,
    weighted_average: number;
}

export interface BaseLayoutProps {
    children: ReactNode;
}

export interface ModalProps {
    children: ReactNode;
}

export interface ModalContextType {
    onClose: () => void;
}

export enum TypeForm  {
    create="create",
    update="update"
}

export type NewUser = {
    full_name: string;
    password: string;
    email: string;
}

export type User = {
    full_name: string;
    password: string;
    email: string;
}
